import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "../components/ui";
import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";

/**
 * Shared top-level shell: sidebar (mobile) + unified MainNavbar.
 * Used by DefaultLayout, SignupLayout, and the landing page.
 */
const AppChrome = ({ children, noNavbar = false }) =>
  window.screen.width < 767 ? (
    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
      <Row>
        <MainSidebar />
        <Col
          className="main-content p-0"
          lg={{ size: 10, offset: 2 }}
          md={{ size: 9, offset: 3 }}
          sm="12"
          tag="main"
        >
          {!noNavbar && <MainNavbar />}
          {children}
        </Col>
      </Row>
    </Container>
  ) : (
    <React.Fragment>
      <MainSidebar />
      {!noNavbar && <MainNavbar />}
      {children}
    </React.Fragment>
  );

AppChrome.propTypes = {
  children: PropTypes.node,
  noNavbar: PropTypes.bool,
};

export default AppChrome;
